import { ArrowRight } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ForwardIcon = DeckardIconWrapper({ Icon: ArrowRight });
